import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyAadharPanLink } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data7 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";


const AadharPankLink = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState({});
  const [errors, setErrors] = useState({});
  const { serviceName } = useService();
  const [profileData, setProfileData] = useState({});
  const [aadharNumber, setAadharNumber] = useState("");
  const [dob, setDob] = useState("");

  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  // Form validation
  const validateForm = (aadharNumber) => {
    const errors = {};
  
    // DL number must be 2 letters + 13 digits = 15 characters
    const dlRegex = /^[A-Z]{2}[0-9]{13}$/;
  
    if (!aadharNumber.trim()) {
      errors.aadharNumber = "Driving License number is required.";
    } else if (!dlRegex.test(aadharNumber.toUpperCase())) {
      errors.aadharNumber = "DL number must be 2 letters followed by 13 digits (e.g., BR0420270023150).";
    }
  
    return errors;
  };
  
  
  
  const handleSubmit = async () => {
    const validationErrors = validateForm(aadharNumber);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setIsLoading(true);

      const response = await verifyAadharPanLink({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        aadhar_number: aadharNumber
      });

      const statusCode = response?.status?.code || response?.status;
      if (statusCode === 200) {
        const dlData = response?.data;


        // ✅ Check if valid object or array
        if (listData && (typeof listData === "object" || Array.isArray(listData))) {
            setListData(listData);
          showSuccessToast(response.status?.message || "Aadhaar pan link check successful.");

          // Clear form
          setAadharNumber("");
          setErrors({});
        } else {
          showErrorToast("aadhar No. missing or in an unexpected format.");
        }
      } else if (statusCode === 422) {
        const backendErrors = response.data.message || {};

        showErrorToast(response.data.message || "Invalid format or data.");
    } else if (statusCode === 500) {
     const errorMessage = response.data.message || response?.message || "Server error occurred";
         showErrorToast(errorMessage);
      }
       else {
        showErrorToast(response.status?.message || `Unexpected error occurred (code: ${statusCode})`);
      }     
    } catch (error) {
      console.error("Aadhar Details Error:", error);
      showErrorToast("Failed to verify Aadhar  details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 justify-center md:ml-80 ml-0 p-4">
      
      
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1  rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

        <InputWithLabel
          type="text"
          label="Aadhar Number"
          placeholder="Enter Aadhar Number"
          maxLength=""
          className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          name="aadhar_number"
          id="aadhar_number"
          required={true}
          value={aadharNumber}
          onChange={(e) => setAadharNumber(e.target.value)}
          error={errors.aadharNumber}
        />

        <div>
          <Button
            type="button"
            className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
            id="verifyAadharPanLink"
            name="verifyAadharPanLink"
            text="Verify"
            onClick={handleSubmit}
          />
        </div>
      </div>

     
      {listData &&
  typeof listData === "object" &&
  listData.masked_pan &&
  listData.client_id && 
  (
    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2 px-2">

<div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-2 hover:shadow-2xl transition duration-300">
  <h2 className="text-lg font-semibold text-blue-800 mb-1">Aadhar Pan Link JSON Data</h2>
  <pre className="bg-gray-100 p-1 rounded text-sm overflow-y-auto max-h-[485px]"> {/* Fixed height set here */}
    {JSON.stringify(listData, null, 2)}
  </pre>
</div>

      </div>

  )}

    </>
  );
};

export default AadharPankLink;
